import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {ROUTES} from '../config';
import SearchFilter from '../components/search-filter';

export default withRouter(
	connect(
		(state) => ({
			searchTerm: state.app.searchTerm,
		}),
		(dispatch, ownProps) => ({
			handleFocus: () => {
				if (ownProps.location.pathname !== ROUTES.LIST.path) {
					ownProps.history.push(ROUTES.LIST.path);
				}
				dispatch({type: 'SET_SEARCH', isFocusOnSearch: true});
			},
			handleBlur: (searchTerm) =>
				dispatch({
					type: 'SET_SEARCH',
					isFocusOnSearch: false,
					searchTerm: searchTerm,
				}),
			setSearchTerm: (searchTerm) =>
				dispatch({
					type: 'SET_SEARCH',
					isFocusOnSearch: true,
					searchTerm: searchTerm,
				}),
		})
	)(SearchFilter)
);
